import { render, staticRenderFns } from "./ConfigSection.vue?vue&type=template&id=049f9589&scoped=true&"
import script from "./ConfigSection.vue?vue&type=script&lang=js&"
export * from "./ConfigSection.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSection.vue?vue&type=style&index=0&id=049f9589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f9589",
  null
  
)

export default component.exports